import { IonModal } from '@ionic/react'
import { Box, Button, Stack, styled, Typography } from '@mui/material'
import { FC, ReactNode } from 'react'

type IonInformationModalProps = {
  open: boolean
  title: string
  content: string | ReactNode
  buttons: ReactNode
  cancelText?: string
  onClose: () => void
}

export const IonInformationModal: FC<IonInformationModalProps> = ({
  open,
  title,
  content,
  buttons,
  cancelText,
  onClose,
}) => (
  <IonModalStyled isOpen={open} animated={false} onDidDismiss={onClose}>
    <Box
      sx={{
        px: 5,
        py: 7,
        width: theme => `calc(280px - ${theme.spacing(5)} * 2)`,
        textAlign: 'center',
        bgcolor: 'grey.100',
      }}
    >
      <Typography variant="h5" sx={{ pb: 3 }}>
        {title}
      </Typography>
      {typeof content === 'string' ? (
        <Typography variant="body2" sx={{ pb: 7 }}>
          {content}
        </Typography>
      ) : (
        content
      )}
      <Stack spacing={4} alignItems="center">
        {buttons}
        <Button variant="text" color="primary" onClick={onClose}>
          {cancelText}
        </Button>
      </Stack>
    </Box>
  </IonModalStyled>
)

const IonModalStyled = styled(IonModal)(({ theme }) => ({
  '--width': 'fit-content',
  '--height': 'fit-content',
  '--border-radius': theme.spacing(3),
}))
